import { API } from "aws-amplify";
import { useState, useEffect } from "react";
import { ListExamCodes } from "../graphql/queries";
import { Box, Card, Cards, Data, DataSearch, Select, Text } from "grommet";

export default function NewExamCodes() {
  const [examCodes, setExamCodes] = useState([]);
  const [selectedExamCode, setSelectedExamCode] = useState(null);
  const [keys, setKeys] = useState([]);

  useEffect(() => {
    const fetchExamCodes = async () => {
      const data = await API.graphql({
        query: ListExamCodes,
      });
      console.log(data);
      let temp = data.data.listExamCodes.items.map((item) => {
        return {
          ...item,
          newName: `${item.client_name} - ${item.exam_name}`,
        };
      });
      setExamCodes(temp);
    };
    fetchExamCodes();
  }, []);

  const handleSelect = (event) => {
    console.log(event.value);
    //parse each item in the data array of the selected exam code
    let tempData = event.value.data.map((item) => {
      return JSON.parse(item);
    });
    console.log(tempData);
    let temp = {
      ...event.value,
      data: tempData,
    };
    let tempKeys = Object.keys(tempData[0]);
    setKeys(tempKeys);
    console.log(temp);
    setSelectedExamCode(temp);
  };

  return (
    <Box align="center" justify="center" pad="medium" gap="medium">
      <Box width="medium">
        <Select
          options={examCodes}
          value={selectedExamCode}
          onChange={handleSelect}
          labelKey="newName"
          valueKey="id"
          placeholder="Select an exam"
        />
      </Box>
      <Box width="medium" gap="small">
        <Data data={selectedExamCode?.data} gap="small">
          <Text>Search for a tester</Text>
          <DataSearch />
          <Cards>
            {(item) => (
              <Card pad="small">
                <Box>
                  {keys.map((key) => (
                    <Box key={key} direction="row" gap="small">
                      <Text weight="bold">{key}</Text>
                      <Text>{item[key]}</Text>
                    </Box>
                  ))}
                </Box>
              </Card>
            )}
          </Cards>
        </Data>
      </Box>
    </Box>
  );
}
